<template>
 <div class="container">
        <h2>开卡前请阅此说明，开通即视为同意全部内容。</h2>
        <h2>一、赠送余额领取规则</h2>
        <p>每次开通均立返对应档位的赠送余额，每日福利需进入省钱卡页面手动领取当日的赠送余额。</p>

        <h2>二、省钱卡有效期规则</h2>
        <p>省钱卡有效期自开通当日起算，其中：</p>
        <ul>
            <li>周卡：7 天</li>
            <li>月卡：30 天</li>
            <li>季卡：90 天</li>
        </ul>
        <p>多次开通省钱卡，不可叠加，省钱卡最高有效天数不超过 <span class="highlight">720 天</span>。</p>

        <h2>三、赠送余额使用规则</h2>
        <ul>
            <li>开通立返的各档位赠送余额和每日领取的赠送余额无期限，可叠加。</li>
            <li>每日福利赠送余额逾期未领取无法补领，请在当日及时领取。</li>
            <li>赠送余额仅在游戏内支付使用(抵扣方式以游戏内显示为准)不可提现、转账及购买其他商品。</li>
        </ul>

        <h2>四、赠送余额适用游戏范围</h2>
        <ul>
            <li>省钱卡立返和每日领取的赠送余额可在平台绝大多数游戏中使用，具体支持使用的游戏名单，可在省钱卡页面的可用游戏清单中查看。</li>
        </ul>


        <h2>五、特别提醒</h2>
        <div class="tip-box">
            <p>1. 省钱卡属于虚拟商品，不支持退货，开通前请确认所游玩游戏是否支持赠送余额使用。</p>
            <p>2. 未成年用户无法开通及使用本省钱卡相关功能。</p>
            <p>3. 若对省钱卡规则、赠送余额使用等有任何疑问，可及时联系客服咨询。</p>
            <p>4. 开通省钱卡金额，不参与平台余额累充活动。</p>
            <p>5. 本规则最终解释权归平台所有。</p>
        </div>
    </div>
</template>
<script>
import { useRouter } from "vue-router";
import { reactive, onMounted } from "vue";
import { useStore } from "vuex";
import { monthCardCouponRecord } from "@/api/yzuser.js";
import { setToken, getToken, getUid } from "@/utils/auth";
import { getQueryString } from "@/utils/location";
import { Toast } from "vant";
export default {
  name: "monthCardDesc",
  setup() {
    const router = useRouter();
    const store = useStore();
    const state = reactive({
      getLists: [],
    });
    onMounted(() => {});
    return {
      state,
    };
  },
};
</script>
<style scoped="scoped">


 * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
            font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
        }

        body {
            background-color: #ffffff;
            color: #333;
            line-height: 1.8;
            font-size: 15px;
            padding: 15px;
        }

        .container {
          padding: 0 32px;
        }


        h1 {
            font-size: 20px;
            text-align: center;
            margin-bottom: 25px;
            font-weight: 600;
            color: #222;
            padding-bottom: 15px;
            border-bottom: 1px solid #eee;
            height: 100px;
            line-height: 100px;
        }

        h2 {
            font-size: 17px;
            margin: 28px 0 12px;
            font-weight: 600;
            color: #222;
            display: flex;
            align-items: center;
        }

        h2::before {
            content: "";
            display: inline-block;
            width: 4px;
            height: 18px;
            background-color: #00D9C5;
            margin-right: 10px;
            border-radius: 2px;
        }

        p {
            margin: 8px 0;
            text-align: justify;
        }

        ul {
            margin: 10px 0 10px 20px;
        }

        li {
            margin: 6px 0;
        }

        .highlight {
            color: #000000;
            font-weight: 600;
        }

        .rule-table {
            width: 100%;
            border-collapse: collapse;
            margin: 15px 0;
            font-size: 14px;
        }

        .rule-table th,
        .rule-table td {
            border: 1px solid #e5e5e5;
            padding: 10px 8px;
            text-align: left;
        }

        .rule-table th {
            background-color: #f8f9fa;
            font-weight: 600;
        }

        .tip-box {
            background-color: #f8ffff;
            border: 1px solid #d6ffee;
            border-radius: 8px;
            padding: 12px;
            margin: 15px 0;
            font-size: 14px;
        }

        .remind {
            margin-top: 20px;
            padding-top: 15px;
            border-top: 1px dashed #eee;
        }
      @media screen and (max-width: 800px) {
            body {
                font-size: 14px;
            }

            h1 {
                font-size: 18px;
            }

            h2 {
                font-size: 16px;
            }

            .rule-table {
                font-size: 13px;
            }

          .tip-box {
              font-size: 14px;
          }
        }
</style>
